export class SetMadeCompliancePhoneCallDto {
  madeCompliancePhoneCall: boolean;

  constructor(madeCompliancePhoneCall: boolean) {
    this.madeCompliancePhoneCall = madeCompliancePhoneCall;
  }
}
